import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/model_hub/analytics/analytics.py
export const MODEL_HUB_ANALYTICS_ACTIONS = {
  CLICKED_STRUCTURE_PREDICTION_RUN_ALL_MODELS: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'structure_prediction_click_run_all_models',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  MODEL_HUB_VIEWED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub_viewed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  MODEL_HUB_MODEL_CARD_CLICKED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub_model_card_clicked',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RUNS_TAB_VIEWED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.runs_tab.viewed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RUNS_TAB_FILTERED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.runs_tab.filtered',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RUNS_TAB_SORTED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.runs_tab.sorted',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RUNS_TAB_PAGE_CHANGED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.runs_tab.page_changed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RUNS_TAB_PAGE_SIZE_CHANGED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.runs_tab.page_size_changed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PREDICTION_JOBS_TAB_VIEWED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.prediction_jobs_tab.viewed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  INTERACTED_MODEL_HUB_PREVIEW_VIEWER: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.prediction_jobs_tab.interacted_preview_viewer',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DATA_FIRST_TAB_VIEWED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.data_first_tab.viewed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DATA_FIRST_BATCH_SUBMITTED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.data_first.batch_submitted',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  STRUCTURE_TAB_BANNER_CLICKED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.structure_tab.bulk_predictions_banner_clicked',
    actionCategory: ACTION_CATEGORY.READ,
  },
  // Standalone signup wizard funnel. The account-creation event itself is emitted server-side
  // (MODEL_HUB_USER_SIGNED_UP in benchling/model_hub/views/signup.py); these are client-side
  // funnel telemetry, including the analytics-only "your work" survey answers.
  SIGNUP_VIEWED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.viewed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SIGNUP_EMAIL_SUBMITTED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.email_submitted',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SIGNUP_GOOGLE_INITIATED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.google_initiated',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SIGNUP_GOOGLE_RETURNED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.google_returned',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SIGNUP_GOOGLE_CANCELED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.google_canceled',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SIGNUP_CODE_VERIFIED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.code_verified',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SIGNUP_SURVEY_SUBMITTED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.survey_submitted',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SIGNUP_COMPLETED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.completed',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SIGNUP_EMAIL_SUBMIT_FAILED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.email_submit_failed',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SIGNUP_CODE_VERIFICATION_STARTED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.code_verification_started',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SIGNUP_CODE_VERIFICATION_FAILED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.code_verification_failed',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SIGNUP_CODE_RESENT: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.code_resent',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SIGNUP_PROFILE_CONTINUE_CLICKED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.profile_continue_clicked',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SIGNUP_SURVEY_SKIPPED_OR_BACK_CLICKED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.survey_skipped_or_back_clicked',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SIGNUP_EXITED_TO_SIGN_IN: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.exited_to_sign_in',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SIGNUP_EXITED_TO_HOME: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.exited_to_home',
    actionCategory: ACTION_CATEGORY.READ,
  },
  MODEL_CARD_CONFIGURE_CLICKED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.model_card.configure_clicked',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RUN_CONFIG_INPUT_METHOD_SELECTED_MANUAL: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.run_config.input_method_selected_manual',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RUN_CONFIG_INPUT_METHOD_SELECTED_UPLOAD: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.run_config.input_method_selected_upload',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SIDEBAR_NAV_CLICKED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.sidebar.nav_clicked',
    actionCategory: ACTION_CATEGORY.READ,
  },
  BATCHES_BATCH_OPENED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.batches.batch_opened',
    actionCategory: ACTION_CATEGORY.READ,
  },
  BATCHES_PREDICTION_OPENED_FROM_BATCH: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.batches.prediction_opened_from_batch',
    actionCategory: ACTION_CATEGORY.READ,
  },
  BATCHES_VIEW_PREDICTIONS_CLICKED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.batches.view_predictions_clicked',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PREDICTIONS_PREDICTION_OPENED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.predictions.prediction_opened',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DOWNLOAD_RESULTS_ZIP_CLICKED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.download.results_zip_clicked',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DOWNLOAD_STRUCTURE_PDB_OR_MMCIF_CLICKED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.download.structure_pdb_or_mmcif_clicked',
    actionCategory: ACTION_CATEGORY.READ,
  },
  MODELS_VIEWED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.models.viewed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  MODELS_SEARCHED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.models.searched',
    actionCategory: ACTION_CATEGORY.READ,
  },
  MODELS_SEARCH_CLEARED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.models.search_cleared',
    actionCategory: ACTION_CATEGORY.READ,
  },
  MODELS_VIEW_TOGGLED_TO_LIST: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.models.view_toggled_to_list',
    actionCategory: ACTION_CATEGORY.READ,
  },
  MODELS_VIEW_TOGGLED_TO_GRID: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.models.view_toggled_to_grid',
    actionCategory: ACTION_CATEGORY.READ,
  },
  NEW_PREDICTION_OPENED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.new_prediction.opened',
    actionCategory: ACTION_CATEGORY.READ,
  },
  NEW_PREDICTION_MODEL_ADDED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.new_prediction.model_added',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  NEW_PREDICTION_MODEL_REMOVED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.new_prediction.model_removed',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  NEW_PREDICTION_INPUT_ROW_ADDED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.new_prediction.input_row_added',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  NEW_PREDICTION_INPUT_ROW_REMOVED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.new_prediction.input_row_removed',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  NEW_PREDICTION_IMPORT_TEMPLATE_DOWNLOADED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.new_prediction.import_template_downloaded',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RUN_CONFIG_UPLOAD_FILE_CLICKED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.run_config.upload_file_clicked',
    actionCategory: ACTION_CATEGORY.READ,
  },
  NEW_PREDICTION_SUBMIT_CLICKED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.new_prediction.submit_clicked',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  NEW_PREDICTION_SUBMIT_FAILED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.new_prediction.submit_failed',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  NEW_PREDICTION_SUBMIT_SUCCEEDED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.new_prediction.submit_succeeded',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  PREDICTIONS_FILTERED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.predictions.filtered',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PREDICTIONS_SORTED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.predictions.sorted',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PREDICTIONS_PAGINATION_CHANGED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.predictions.pagination_changed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PREDICTION_DETAIL_VIEWED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.prediction_detail.viewed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PREDICTION_DETAIL_DOWNLOAD_SETTINGS_CLICKED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.prediction_detail.download_settings_clicked',
    actionCategory: ACTION_CATEGORY.READ,
  },
  AUTH_REDIRECTED_TO_SIGN_IN_FOR_GATED_ACTION: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.auth.redirected_to_sign_in_for_gated_action',
    actionCategory: ACTION_CATEGORY.READ,
  },
  AUTH_REDIRECTED_TO_SIGN_UP_FOR_GATED_ACTION: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.auth.redirected_to_sign_up_for_gated_action',
    actionCategory: ACTION_CATEGORY.READ,
  },
};

/**
 * Identifies where a prediction batch was triggered from.
 * Keep in sync with benchling/model_hub/constants.py PredictionBatchSource
 */
export const MODEL_RUN_SOURCE = {
  STRUCTURE_TAB: '3d_structure_tab',
  MODEL_HUB_UI: 'model_hub_ui',
  AI_CHAT: 'ai_chat',
  V3_API: 'v3_api',
} as const;

export type PredictionBatchSource = (typeof MODEL_RUN_SOURCE)[keyof typeof MODEL_RUN_SOURCE];
